import React, { type FocusEventHandler, type MouseEvent, forwardRef, useState } from "react";
import getTime from "date-fns/getTime";
import formatter from "date-fns/format";

import { SupCalendar, SupXCircle } from "../../../../icons";
import { CommonColors } from "../../../../types/colors";

import { InputButton } from "./InputButton";

interface DateInputProps {
  id?: string;
  name?: string;
  value?: Date;
  color?: CommonColors;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  fluid?: boolean;
  format: string;
  onFocus?: FocusEventHandler<HTMLButtonElement>;
  onBlur?: FocusEventHandler<HTMLButtonElement>;
  onClick?: () => void;
  onClear?: () => void;
}

export const DateInput = forwardRef<HTMLButtonElement, DateInputProps>(
  ({ id, name, value, color, disabled, placeholder, className, fluid, format = "", onFocus, onBlur, onClick, onClear }, ref) => {
    const [hovered, setHovered] = useState(false);

    function handleClear(e: MouseEvent<SVGSVGElement>) {
      e.stopPropagation();
      onClear?.();
    }

    const suffixIcon = hovered && Boolean(value) ? <SupXCircle onClick={handleClear} /> : <SupCalendar />;

    return (
      <>
        <InputButton
          fluid={fluid}
          className={className}
          ref={ref}
          disabled={disabled}
          placeholder={placeholder}
          color={color}
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={onClick}
          suffixIcon={suffixIcon}
          onMouseEnter={() => {
            setHovered(true);
          }}
          onMouseLeave={() => {
            setHovered(false);
          }}
        >
          {value ? formatter(value, format) : ""}
        </InputButton>

        <input type="hidden" id={id} name={name} value={value ? getTime(value) : ""} />
      </>
    );
  }
);

DateInput.displayName = "DateInput";
